<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg"  style="background-image: url(static/video/banner.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                         <!-- 视频资料 -->
                         {{ $t('header.mb_videoData') }}
                    </h1>
                    <h3>
                        <!-- 奥太电气视频资源 -->
                         {{ $t('resource.resource_video_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'mb_home' }">
                              <!-- 首页 -->
                             {{ $t('header.home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item >
                              <!-- 视频资料 -->
                             {{ $t('header.mb_videoData') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
      
           <!-- 菜单 -->
         <!-- <section class="menu_common" >
            <div class="container" >
                <div class="menu_row tab-buttons">
                    <div class="menu_li">
                            <div class="menu_li_title " :class="videoType == 'publicize' ? 'active-btn' : ''"  @click="handleReplace('publicize')">宣传视频</div>
                    </div>
                    <div  class="menu_li" >
                        <div  class="menu_li_title" :class="videoType == 'industry' ? 'active-btn' : ''"  @click="handleReplace('industry')" >行业视频</div>
                    </div>
                </div>
            </div>
          
        </section> -->

        <!-- 内容 -->
        <section class="blog-one">
            <div class="container">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" v-for="(item,index) in list" :key="index" :data-wow-delay="(index+1)*100+'ms'">
                        <div class="blog-one__single" @click="handleDetail(item)">
                            <div class="blog-one__img">
                                <img :src="item.imgUrl" alt="">
                                <a>
                                    <i style="color: var(--notech-white);" class="el-icon-video-play"></i>
                                </a>
                            </div>
                            <div class="blog-one__content">
                                <h3 class="blog-one__title">
                                    <a>
                                        {{ item.name }}
                                     <!-- {{ $t(`resource.${item.i18n_name}`) }} -->
                                    </a>
                                </h3>
                            </div>
                        </div>
                    </div>
                        

                    <div class="col-lg-12">
                            <div  class="blog-pagination justify-content-center">
                            <el-pagination
                                background
                                layout="prev, pager, next"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="queryParam.pageNum"
                                :page-sizes="[9, 18, 27, 36]"
                                :page-size="queryParam.pageSize"
                            
                                :total="total"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
              
            </div>
        </section>

        <div v-if="dialogVisible" style="width: 100%;">
            <el-dialog  :visible.sync="dialogVisible" @closed="handleClose" :close-on-click-modal="false" :destroy-on-close="true">
                <!-- <video v-if="dialogVisible" id="videoElement" class="dialog-video" ref="videoPlayer"  :playsinline="true" autoplay="autoplay" loop="loop" :src="videoSrc" controls=""></video> -->
                  <iframe 
                    :src="videoSrc" 
                    scrolling="no" 
                    border="0" 
                    frameborder="no" 
                    framespacing="0" 
                    width="100%"
                    height="100%"
                    sandbox="allow-top-navigation allow-same-origin allow-forms allow-scripts"    

                    allowfullscreen="allowfullscreen"
                    id="iframe_div"

                ></iframe>

            </el-dialog>
        </div>
        
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'mbVideo',
     mixins: [MixinsList],
    data () {
        return {
            list: [],
            queryParam: {
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            dialogVisible: false,
            videoSrc: "",
             videoType: "publicize",  // 视频类型 publicize-宣传  industry--行业
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    methods: {
        // 分页方法
        handleSizeChange(i, j) {
            Object.assign(this.queryParam, { pageSize: i })
            this.getList()
        },
        handleCurrentChange(i, j) {
            Object.assign(this.queryParam, { pageNum: i })
            this.getList()
        },
        // 获取内容
        async getList() {
            this.list = []
            try {
            const  result  = await loadData('video', this.lang)
            console.log("result",result)
            var arr = JSON.parse(JSON.stringify(result[this.videoType]))  
            this.total = arr.length
            var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
            this.list = arr.splice(p,this.queryParam.pageSize)
            } catch (error) {
                console.log("error",error)
            }
        },
        // 详情页面
        handleDetail(item) {
            this.videoSrc = item.downUrl
            this.dialogVisible = true
        },
        handleClose() {
            // this.dialogVisible = false
            // let myPlayer = this.$refs.videoPlayer.player;
            // myPlayer.pause()
            var video = document.getElementById('videoElement');
            video.pause();
            video.src = '';    
            video.currentTime = 0;
            var parentElement = video.parentNode;
            parentElement.removeChild(video);

            video.remove();
            video.innerHTML = "";
            video.outerHTML  = "";
            this.dialogVisible = false
        },

        handleReplace(val){
             this.videoType = value
            this.queryParam.pageNum = 1
            this.getList()
        }
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}
/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    font-size: 16px;
    font-weight: 700;
    transition: all 500ms ease;
}

.page-header__inner h1 {
    text-align: center;
    font-size: var(--font-size-20) !important;
    text-justify: distribute-all-lines;  /*兼容ie*/
}
.page-header__inner h3 {
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
}
.main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}


.blog-one__single {
    cursor: pointer;
}
.blog-one__content {
    padding: 30px 20px 29px;
}
.blog-one__title {
    /* height: 91px; */
    overflow:hidden; /* 溢出的内容隐藏 */
    text-overflow:ellipsis; /*  溢出的部分用省略号...显示 */
    display:-webkit-box; /* 将对象作为弹性伸缩盒子模型显示  */
    -webkit-line-clamp:3; /* 行数 */
    -webkit-box-orient:vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
}


::v-deep .el-dialog {
    width: 100%;
    box-shadow: none;
	background: transparent;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: var(--notech-white) !important;
    
}
::v-deep .el-dialog__body {
    display: flex;
    align-items: center;
    height: 300px;
    width: 100%;
}
.dialog-video {
    max-width: 100%;
    max-height: 100%;
}
</style> 
